import { useEmployeeListFilterActive } from './useEmployeeListFilterActive';
import { useSourceFilterEnabled } from './useSourceFilterEnabled';

/**
 * The `hiddenInEmployeeList` request value implied by the tenant's SOURCE_FILTER preference:
 * `false` (exclude hidden employees) when the feature is enabled and the per-tenant toggle is active,
 * otherwise `undefined` (no restriction). Single source of truth for what the filter means, so lists,
 * counts and charts stay in sync.
 */
export function useHiddenEmployeeFilterValue(): boolean | undefined {
  const enabled = useSourceFilterEnabled();
  const [filterActive] = useEmployeeListFilterActive();

  return enabled && filterActive ? false : undefined;
}
